module.exports = __webpack_public_path__ + "static/img/deleted_icon.5c1d20b9.png";